<template>
    <el-dialog
        :title="(isForm ? (formId ? '编辑' : '添加') : '查看') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="分组名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入分组名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="分组顺序">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="分组状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addApiGroup, getApiGroupDetail, putApiGroup } from '@/api/apigroup.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    name: '',
    id: '',
    list_order: 1,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入分组名称'
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputApiGroup()
    } else {
        await doaddApiGroup()
    }
}

// 修改
const doputApiGroup = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await putApiGroup(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加
const doaddApiGroup = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await addApiGroup(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取详情
const getApiGroupDetailFun = async () => {
    const data = await getApiGroupDetail(props.formId)
    formData.value = {
        name: data.name,
        id: data.id,
        list_order: data.list_order,
        status: data.status,
        visible: data.visible
    }
    dialogTitle.value = data.name
}

// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getApiGroupDetailFun()
        } else {
            formData.value = {
                name: '',
                id: '',
                list_order: 1,
                status: 1,
                visible: 1
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
